var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100", attrs: { id: "page-content-wrapper" } },
    [
      _c(
        "div",
        { staticClass: "dashboard-main" },
        [
          _c("nav", { staticClass: "dt-fixed-nav" }, [
            _c("div", { staticClass: "dt-user-info" }, [
              _c(
                "span",
                { staticClass: "dt-user-avatar" },
                [_c("fa", { attrs: { icon: ["fas", "user"] } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "dt-user-greeting" }, [
                _c("span", { staticClass: "dt-user-greeting-label" }, [
                  _vm._v("Welcome back"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "dt-user-greeting-name" }, [
                  _vm._v(_vm._s(_vm.user ? _vm.user.name : "")),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dt-nav-actions" }, [
              _c(
                "button",
                {
                  staticClass: "notif-bell-btn",
                  class: {
                    "notif-bell-btn--active": _vm.notifPanelOpen,
                    "notif-bell-btn--pulse":
                      _vm.notifUnreadCount > 0 && !_vm.notifPanelOpen,
                  },
                  on: {
                    click: function ($event) {
                      _vm.notifPanelOpen = !_vm.notifPanelOpen
                    },
                  },
                },
                [
                  _c("fa", { attrs: { icon: ["fas", "bell"] } }),
                  _vm._v(" "),
                  _vm.notifUnreadCount > 0
                    ? _c("span", { staticClass: "notif-bell-badge" }, [
                        _vm._v(
                          _vm._s(
                            _vm.notifUnreadCount > 99
                              ? "99+"
                              : _vm.notifUnreadCount
                          )
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.globalIsUserAllowed("Change_Password")
                ? _c(
                    "button",
                    {
                      staticClass: "dt-nav-btn",
                      attrs: {
                        disabled: _vm.isTestAccount,
                        title: _vm.isTestAccount
                          ? "Cannot change password of test account"
                          : "Change Password",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.show("PTVChangePasswordModal")
                        },
                      },
                    },
                    [_c("fa", { attrs: { icon: ["fas", "key"] } })],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.globalIsUserAllowed("Release_History")
                ? _c(
                    "button",
                    {
                      staticClass: "dt-nav-btn",
                      attrs: { title: "Release History" },
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.show("PTVHistoryModal")
                        },
                      },
                    },
                    [_c("fa", { attrs: { icon: ["fas", "history"] } })],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "dt-nav-btn dt-signout-btn",
                  attrs: { title: "Sign Out" },
                  on: { click: _vm.signOut },
                },
                [_c("fa", { attrs: { icon: ["fas", "sign-out-alt"] } })],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard-scroll" }, [
            _c("div", { staticClass: "container-fluid mt-4" }, [
              _c("div", { staticClass: "dash-header mb-4" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "dash-header-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-request-sample",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.callMap()
                        },
                      },
                    },
                    [
                      _c("fa", {
                        staticClass: "mr-2",
                        attrs: { icon: ["fas", "plus"] },
                      }),
                      _vm._v(
                        "\n                    Request Data\n                "
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-cards mb-4" }, [
                _c(
                  "div",
                  {
                    class: [
                      "stat-card",
                      "stat-card--na",
                      _vm.cardClass("North America"),
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.selectRegion("North America")
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "stat-map-panel" }, [
                      _c("div", { staticClass: "stat-map-glow" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "stat-map-img",
                        attrs: {
                          src: _vm.northAmericaImg,
                          alt: "North America",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-body" }, [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("North America"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.naCount)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v("Requests Generated"),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: ["stat-card", _vm.cardClass("Europe")],
                    on: {
                      click: function ($event) {
                        return _vm.selectRegion("Europe")
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "stat-map-panel" }, [
                      _c("div", {
                        staticClass: "stat-map-glow stat-map-glow--eu",
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "stat-map-img",
                        attrs: { src: _vm.europeImg, alt: "Europe" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-body" }, [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Europe"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.euCount)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v("Requests Generated"),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: ["stat-card", _vm.cardClass("Japan")],
                    on: {
                      click: function ($event) {
                        return _vm.selectRegion("Japan")
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "stat-map-panel" }, [
                      _c("div", {
                        staticClass: "stat-map-glow stat-map-glow--jp",
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "stat-map-img",
                        attrs: { src: _vm.japanImg, alt: "Japan" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-body" }, [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Japan"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.jpCount)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v("Requests Generated"),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: ["stat-card", _vm.cardClass("Middle East")],
                    on: {
                      click: function ($event) {
                        return _vm.selectRegion("Middle East")
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "stat-map-panel" }, [
                      _c("div", {
                        staticClass: "stat-map-glow stat-map-glow--me",
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "stat-map-img",
                        attrs: { src: _vm.middleEastImg, alt: "Middle East" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-body" }, [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Middle East"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.meCount)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v("Requests Generated"),
                      ]),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-12" }, [
                  _c("div", { staticClass: "table-wrapper" }, [
                    _c("div", { staticClass: "table-header" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "table-header-right" },
                        [_c("fa", { attrs: { icon: ["fas", "layer-group"] } })],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "tableScroll",
                        staticClass: "ptv-table-scroll",
                        style: { maxHeight: _vm.tableHeight },
                      },
                      [
                        _c("vue-good-table", {
                          ref: "ptvDashboardTable",
                          attrs: {
                            id: "ptvDashboardTable",
                            rows: _vm.filteredRows,
                            columns: _vm.tableColumns,
                            "pagination-options": _vm.pagination,
                            "sort-options": {
                              enabled: true,
                              initialSortBy: { field: "id", type: "desc" },
                            },
                            styleClass: "vgt-table",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "column-filter",
                              fn: function (props) {
                                return [
                                  props.column.field == "created_date"
                                    ? _c("b-form-input", {
                                        attrs: {
                                          type: "date",
                                          placeholder: "Select Requested Date",
                                          format: "mm/dd/yyyy",
                                        },
                                        on: {
                                          input: (val) =>
                                            _vm.dateFilter(val, "created_date"),
                                        },
                                      })
                                    : props.column.field == "delivery_date"
                                    ? _c("b-form-input", {
                                        attrs: {
                                          placeholder: "Select Delivery Date",
                                          type: "date",
                                          format: "mm/dd/yyyy",
                                        },
                                        on: {
                                          input: (val) =>
                                            _vm.dateFilter(
                                              val,
                                              "delivery_date"
                                            ),
                                        },
                                      })
                                    : props.column.field === "created_by" &&
                                      _vm.user &&
                                      _vm.user.isAdmin
                                    ? _c("b-form-select", {
                                        staticClass: "w-100",
                                        attrs: {
                                          options: _vm.userOptions,
                                          placeholder: "Select User",
                                        },
                                        on: { change: _vm.applyAllFilters },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "first",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "b-form-select-option",
                                                    { attrs: { value: null } },
                                                    [_vm._v("All Users")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.filters.created_by,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "created_by",
                                              $$v
                                            )
                                          },
                                          expression: "filters.created_by",
                                        },
                                      })
                                    : props.column.field === "status" &&
                                      _vm.user &&
                                      _vm.user.isAdmin
                                    ? _c("b-form-select", {
                                        staticClass: "w-100",
                                        attrs: {
                                          options: _vm.statuses,
                                          placeholder: "Select Status",
                                        },
                                        on: { change: _vm.applyAllFilters },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "first",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "b-form-select-option",
                                                    { attrs: { value: null } },
                                                    [_vm._v("Any")]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.filters.status,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.filters, "status", $$v)
                                          },
                                          expression: "filters.status",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "table-row",
                              fn: function (props) {
                                return [
                                  props.column.field == "wkt"
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: { width: "50px" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.initStatsModal(
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("fa", {
                                            staticStyle: { color: "#4A74A8" },
                                            attrs: {
                                              icon: ["fas", "info-circle"],
                                              size: "lg",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : props.column.field === "status" &&
                                      _vm.user &&
                                      _vm.user.isAdmin
                                    ? _c(
                                        "span",
                                        { staticClass: "status-cell" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "status-wrapper",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "status-badge",
                                                  class: [
                                                    _vm.statusClass(
                                                      props.row.status
                                                    ),
                                                    {
                                                      "badge-open":
                                                        _vm.editingStatusRowId ===
                                                        props.row.id,
                                                    },
                                                  ],
                                                  attrs: {
                                                    title:
                                                      "Click to change status",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleStatusDropdown(
                                                        props.row.id,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "status-dot",
                                                  }),
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        props.row.status || "—"
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                  _c("fa", {
                                                    staticClass:
                                                      "status-chevron",
                                                    class: {
                                                      "chevron-open":
                                                        _vm.editingStatusRowId ===
                                                        props.row.id,
                                                    },
                                                    attrs: {
                                                      icon: [
                                                        "fas",
                                                        "chevron-down",
                                                      ],
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.statusSaving[props.row.id] &&
                                              _vm.statusSaving[props.row.id]
                                                .saved &&
                                              _vm.statusSaving[props.row.id]
                                                .spinner
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "status-save-indicator status-save-indicator--saved",
                                                    },
                                                    [
                                                      _c("fa", {
                                                        attrs: {
                                                          icon: [
                                                            "fas",
                                                            "check",
                                                          ],
                                                          size: "sm",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm.statusSaving[
                                                    props.row.id
                                                  ] &&
                                                  _vm.statusSaving[props.row.id]
                                                    .spinner
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "status-save-indicator",
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "spinner-border spinner-border-sm",
                                                        attrs: {
                                                          role: "status",
                                                          "aria-hidden": "true",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.editingStatusRowId ===
                                              props.row.id
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "status-dropdown",
                                                      style: {
                                                        top:
                                                          _vm.statusDropdownPos
                                                            .top + "px",
                                                        left:
                                                          _vm.statusDropdownPos
                                                            .left + "px",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.statuses,
                                                      function (s) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: s.value,
                                                            staticClass:
                                                              "status-option",
                                                            class:
                                                              _vm.statusClass(
                                                                s.value
                                                              ),
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectStatus(
                                                                  props.row,
                                                                  s.value
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "status-dot",
                                                            }),
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(s.text) +
                                                                "\n                                                "
                                                            ),
                                                            props.row.status ===
                                                            s.value
                                                              ? _c("fa", {
                                                                  staticClass:
                                                                    "status-check",
                                                                  attrs: {
                                                                    icon: [
                                                                      "fas",
                                                                      "check",
                                                                    ],
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    : props.column.field === "status"
                                    ? _c(
                                        "span",
                                        { staticClass: "status-cell" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "status-badge status-badge--readonly",
                                              class: _vm.statusClass(
                                                props.row.status
                                              ),
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "status-dot",
                                              }),
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    props.row.status || "—"
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : props.column.field == "created_date"
                                    ? _c(
                                        "span",
                                        { staticStyle: { width: "50px" } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                new Date(
                                                  props.row.created_date
                                                ).toLocaleDateString(
                                                  _vm.language,
                                                  {
                                                    month: "2-digit",
                                                    day: "2-digit",
                                                    year: "numeric",
                                                  }
                                                ) +
                                                  " , " +
                                                  new Date(
                                                    props.row.created_date
                                                  ).toLocaleTimeString(
                                                    _vm.language,
                                                    {
                                                      hour: "2-digit",
                                                      minute: "2-digit",
                                                    }
                                                  )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    : props.column.field == "delivery_date" &&
                                      props.row.delivery_date != null
                                    ? _c(
                                        "span",
                                        { staticStyle: { width: "50px" } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                new Date(
                                                  props.row.delivery_date
                                                ).toLocaleDateString(
                                                  _vm.language,
                                                  {
                                                    month: "2-digit",
                                                    day: "2-digit",
                                                    year: "numeric",
                                                  }
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticStyle: { width: "50px" } },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                props.row[props.column.field]
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "copyright" }, [
              _c(
                "a",
                {
                  staticClass: "attribution",
                  attrs: {
                    href: "https://dmp-maps.com/legal/",
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "© " +
                      _vm._s(new Date().getFullYear()) +
                      "\n            Dynamic\n            Map Platform North America, Inc. All Rights Reserved"
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("DT_StatsModal", { attrs: { row: _vm.selectedRow } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "notif-drawer",
          class: { "notif-drawer--open": _vm.notifPanelOpen },
        },
        [
          _c("DD_Notifications", {
            attrs: { user: _vm.user },
            on: {
              close: function ($event) {
                _vm.notifPanelOpen = false
              },
              "unread-count": function ($event) {
                _vm.notifUnreadCount = $event
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dash-header-text" }, [
      _c("h5", { staticClass: "dash-title" }, [
        _vm._v("Data Requests Overview"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "dash-subtitle" }, [
        _vm._v("Track and manage your dataset delivery requests"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "table-header-left" }, [
      _c("span", { staticClass: "table-header-title" }, [
        _vm._v("Requests Overview"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }